.widget-container > * {
    margin-top: 16px;
    width: 350px;
}

.connected-container > * {
    margin-top: 16px;
}
